// @flow
export const MIN_BEDROOMS = 0;
export const MAX_BEDROOMS = 50;
export const MIN_BATHROOMS = 0;
export const MAX_BATHROOMS = 50;
export const MIN_PRICE = 0;
export const MAX_PRICES = {
    EUR: 500, // Euros
    ARS: 4500, // Argentine Peso
    COP: 2000000, // Colombian peso
    GBP: 600, // British Pounds
    NOK: 5300, // Norwegian krone
    SEK: 5000, // Swedish krona
    DKK: 5000, // Danish Krone
    INR: 50000, // Indian rupee
    JPY: 100000, // Japan yen
    DEFAULT: 1000
};
